import {Component, Inject, Optional} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {IPerformanceReviewPopUP} from 'src/app/interfaces/hr-data.interface';
import {HrDataService} from 'src/app/services/employee-details/hr-data.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';
import {LinkDocModalComponent} from 'src/app/shared/ui-kits/table/link-doc-modal/link-doc-modal.component';
import {Utils} from 'src/app/shared/utils/utils';
import {DIALOG_DATA, DialogService} from '../../../../services/dialog.service';
import {filter} from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-performance-review',
  templateUrl: './performance-review.component.html',
  styleUrls: ['./performance-review.component.scss'],
})
export class PerformanceReviewComponent {
  public performanceReviewForm!: UntypedFormGroup;
  public linkDownload = ''; // link to download the document
  public isCreate = false;
  public isDatePickerOpened!: boolean;
  public validateAllFormFields = Utils.validateAllFormFields;
  public isFieldInvalid = Utils.isFieldInvalid;

  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: IPerformanceReviewPopUP,
    private dialogService: DialogService,
    private hrDataService: HrDataService
  ) {}

  ngOnInit() {
    if (!this.data.content.id) {
      this.isCreate = true;
    }
    this.performanceReviewForm = new UntypedFormGroup({
      date: new UntypedFormControl(this.data.content.date, [
        Validators.required,
      ]),
      authorID: new UntypedFormControl(this.data.content.authorID),
      employeeId: new UntypedFormControl(this.data.content.employeeId),
      id: new UntypedFormControl(this.data.content.id),
      file: new UntypedFormControl(this.data.content.file),
      pm: new UntypedFormControl(this.data.content.pm, [Validators.required]),
      hr: new UntypedFormControl(this.data.content.hr, [Validators.required]),
      hrId: new UntypedFormControl(
        this.data.content.hr?.name ? this.data.content.hr?.id : null
      ),
      pmId: new UntypedFormControl(
        this.data.content.pm?.name ? this.data.content.pm?.id : null
      ),
      status: new UntypedFormControl(this.data.content.status, [
        Validators.required,
      ]),
      level: new UntypedFormControl(this.data.content.level, [
        Validators.required,
      ]),
      comment: new UntypedFormControl(this.data.content.comment, [
        Validators.maxLength(400),
      ]),
    });
    if (!this.isCreate) {
      const dropdownControls = ['level', 'status', 'pm', 'hr'];
      for (const name of dropdownControls) {
        if (!this.performanceReviewForm.controls[name].value?.name) {
          this.performanceReviewForm.controls[name].setValue(null);
        }
      }
    }
  }

  attachLink(): void {
    this.dialogService
      .open(LinkDocModalComponent, {
        data: null,
        settings: {
          width: '450px',
          height: '250px',
        },
      })
      .afterClosed()
      .pipe(
        untilDestroyed(this),
        filter(res => !!res)
      )
      .subscribe(result => {
        this.performanceReviewForm.get('file')?.setValue(result);
      });
  }

  deleteDocLink(): void {
    this.performanceReviewForm.controls['file'].setValue('');
  }

  saveData() {
    if (this.performanceReviewForm.invalid) {
      this.validateAllFormFields(this.performanceReviewForm);
      return;
    }
    this.dialogRef.close(this.performanceReviewForm.value);
  }

  cancelSave() {
    this.dialogRef.close();
  }

  deletePerformance(): void {
    this.hrDataService
      .deletePerformanceReview(this.data.content.id)
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.dialogRef.close('deleted');
      });
  }

  setHr() {
    this.performanceReviewForm
      .get('hrId')
      ?.setValue(this.performanceReviewForm.get('hr')?.value.id);
  }

  setPm() {
    this.performanceReviewForm
      .get('pmId')
      ?.setValue(this.performanceReviewForm.get('pm')?.value.id);
  }
}
